import React, { useEffect, useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import axios from "axios";
import UserService from "../controllers/UserService";
import AuthService from '../controllers/AuthService';
import { useHistory } from "react-router-dom";
const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/topics/`;

const Story = props => {
    const history = useHistory();
    const [items, setItems] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [topicId, seTopicId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);


    useEffect(() => {
        const topicId = props.topicId
        seTopicId(topicId)
        try {
            axios.get(API_URL + topicId)
                .then((response) => {
                    setItems(response.data.data);
                    let questions = ['', '', ''];
                    if (response.data.data.questions) {
                        questions = [
                            response.data.data.questions[0]['content'],
                            response.data.data.questions[1]['content'],
                            response.data.data.questions[2]['content']
                        ];
                    }
                    setQuestions(questions);
                });
        } catch (error) {

        }
    }, []);

    const startActivity = (topicId) => {
        UserService.startActivity(topicId).then(
            (res) => {
                if (res.data && res.data.status.code === 'SUCCESS') {
                    redirectToActiveActivity()
                }
                return false
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                    AuthService.logout();
                    window.location.href = '/login'
                } else {
                    alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                }
            }
        ).then((res) => {
            if (res) {

            }
        });
    }
    const redirectToActiveActivity = () => {
        try {
            UserService.getActivities({
                'status': 'RUNNING',
                'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room ? AuthService.getCurrentUser().room.id : '',
                'domain': AuthService.getCurrentUser().domain.name 
            }).then((response) => {
                if (response.data.status.code === 'SUCCESS') {
                    history.push(`/activity/live/${response.data.data[0].id}`);
                }
            });
        } catch (error) {

        }
    }

    let html = (
        <div dangerouslySetInnerHTML={{ __html: items.content }} className="anywhere-wrap text-left" />
    );

    const alertStartActivity = () => {
        setShowAlert(true)
    }

    return (
        <div className="text-center main-detail px-4 m-auto">
            <Row>
                <Col xs={12}>
                    <h2 className="primary-text font-sarabun-bold">{items.title}</h2>

                    {props.showExport === '1' && (
                        // <Button className="bluebtn d-inline mb-0 py-1">Export</Button>
                        <div className="d-flex">
                            <Button className="bluesky d-inline py-1 py-md-2 px-5 bt font-sarabun-bold btn btn-primary export-btn m-auto" href={(props.studentId) ? `/report/pdffile/person/${props.activityId}/story/${props.studentId}` :  `/report/pdffile/overview/${props.activityId}/story`} target="_blank"><h5 className="mb-0 font-weight-bold">Export</h5></Button>
                        </div>
                    )}

                    {props.showQuestion === '1' && (
                        <div>
                            <div className="w-100 story-advice border-radius-all-05 p-3">
                                <h3 className="font-sarabun-bold">คำแนะนำสำหรับกิจกรรม</h3>
                                <p>
                                    <div className="w-100 text-center font-sarabun px-md-4">ชวนทุกคนค่อยๆ อ่านเรื่องราวต่อไปนี้ แล้วลองวิเคราะห์คุณค่าผ่าน นิสัยเชิงบวกของบุคคลในเนื้อเรื่องผ่านชุดคำถามผ่านการแลกเปลี่ยนผ่านการ
แสดงความคิดเห็นของเรา ไม่มีถูกผิดบนพื้นฐานความเคารพและให้เกียรติทั้งตัวเราตัวนักเรียนและบุคคลในเรื่องนะคะ...มาเริ่มกันเลย !</div>
                                </p>
                            </div>
                            <div className="w-100 story-content border-radius-all-05 p-3 mt-3">
                                <h3 className="font-sarabun-bold">คำถามชวนคิดจากเรื่องราว</h3>
                                <p>
                                    <div className="text-left pb-1 pb-md-4 mb-2 mb-md-4 font-sarabun mx-md-4" style={{ "borderBottom": "1px solid #000000" }}>{questions[0]}</div>
                                    <div className="text-left pb-1 pb-md-4 mb-2 mb-md-4 font-sarabun mx-md-4" style={{ "borderBottom": "1px solid #000000" }}>{questions[1]}</div>
                                    <div className="text-left font-sarabun px-md-4">{questions[2]}</div>
                                </p>
                            </div>
                        </div>
                    )}
                    <img src={items.imageUrl} className="w-100 py-4"></img>
                    <span className="font-sarabun story-div">{html}</span>

                    {(props.showExport !== '1' && props.hideStart !== '1') && (
                        <div className="w-100 story-notice border-radius-all-05 p-3 mt-3 mb-4 font-sarabun">
                            หากเลือก <b>“เริ่มกิจกรรม”</b> แล้ว ในครั้งหน้าจะไม่สามารถนำบทความนี้มาใช้ได้อีก
                        </div>
                    )}

                    {props.hideStart !== '1' && (
                        <div className="mb-3">
                            <Button className="bluesky d-inline py-2 py-md-2 px-5 mb-3 font-sarabun-bold px-2" onClick={() => alertStartActivity(topicId)}>เริ่มกิจกรรม</Button>
                        </div>
                    )}


                </Col>
            </Row>
            <Modal
                show={showAlert}
                onHide={() => { setShowAlert(false); }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                <Modal.Header closeButton className="alert-header">
                </Modal.Header>
                <Modal.Body className="font-sarabun text-center pb-4 pt-0">
                    <p>หากเริ่มกิจกรรมแล้ว<br />ในครั้งหน้าจะไม่สามารถนำบทความนี้<span className="doNotWrap">มาใช้ได้อีก</span>
และกิจกรรมนี้จะไปขึ้นยังหน้าจอของเด็กๆ <span className="doNotWrap">ในห้องของเราค่ะ</span></p>
                    <Button className="bluesky d-inline py-1 py-md-2 px-5 m-1 font-sarabun-bold border-radius-10" onClick={() => { startActivity(topicId); }}>เริ่มเลย</Button>
                    {/* <Button className="bluebtn d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => {setShowAlert(false);}}>กลับกิจกรรม</Button> */}

                </Modal.Body>
            </Modal>
        </div>
    )

}

export default Story